import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { API_BASE } from '../../callApi'

export const collection = 'serviceLogin'

export const schema = new schemas.Entity(
  collection,
  {},
  {
    idAttribute: 'stateReference',
  }
)

type CreateQueryType = {
  serviceKey: string
  origin: string
  redirectTo: string
}

export const create =
  (callApi: CallApi) =>
  ({ serviceKey, origin, redirectTo }: CreateQueryType) =>
    callApi(`${API_BASE}/login/${serviceKey}`, schema, {
      method: 'POST',
      body: {
        origin,
        redirectTo,
      },
    })

type UpdateQueryType = {
  serviceKey: string
  origin: string
  suffix: string
}

type UpdateBodyType = {
  stateReference: string
}

export const update =
  (callApi: CallApi) =>
  (
    { serviceKey, origin, suffix }: UpdateQueryType,
    { stateReference }: UpdateBodyType
  ) =>
    callApi(`${API_BASE}/login/${serviceKey}${suffix}`, schema, {
      method: 'PUT',
      body: {
        origin,
        stateReference,
      },
    })
